import Component from "../classes/Component";
import {$dom} from "../helpers/dom";
import {$events} from "../helpers/events";

const {addClass, get, removeClass, hasClass} = $dom

const customOffcanvasSelector = '.js-adaptive-custom-offcanvas'
const customOffcanvasBackSelector = '.js-adaptive-custom-offcanvas-back'
const customOffcanvasTitleSelector = '.js-adaptive-custom-offcanvas-title'
const customOffcanvasContentSelector = '.js-adaptive-custom-offcanvas-content'
const adaptiveButtonSelector = '.js-menu-adaptive-button'
const adaptiveAvatarSelector = '.js-menu-avatar'

export default function () {
    const handleOpenOffcanvas = (e) => {
        if (!window.matchMedia('(max-width: 992px)').matches) return

        const customOffcanvas = get(customOffcanvasSelector)
        addClass(customOffcanvas, 'active')
        removeClass(customOffcanvas, 'non-active')

        if (hasClass(e.target.closest('.button'), adaptiveAvatarSelector.slice(1))) {
            const content = get(customOffcanvasContentSelector)
            get(customOffcanvasTitleSelector, customOffcanvas).innerHTML = `
                    <div class="d-flex">
                       <svg class="svg-icon cabinet__icon me-3" width="13" height="16">
                           <use xlink:href="img/sprite.svg#avatar"></use>
                       </svg>
                        
                       <p class="mb-0 text--darkgray">${e.target.textContent}</p>                    
                    </div>
                `

            content.innerHTML = `
                <div class="w-50 mt-4">
                    <div>
                        <div class="mb-4">
                            <div class="bonus d-flex align-items-center justify-content-center h-100">
                                <p class="m-0 text--regular">У вас 150 бонусов</p>
                            </div>
                        </div>
                        
                        <div>
                             <div class="mb-3">
                                <a href="personal.html" class="cabinet__link">Личные данные</a>
                            </div>
                            
                             <div class="mb-3">
                                <a href="orders.html" class="cabinet__link">Заказы</a>
                            </div>
                        </div>
                    </div>
                    
                    <div class="cabinet__button">
                        <hr class="mb-2">
                        
                        <button class="cabinet__button text-start w-100 mt-2 button-empty" type="button">Выйти</button>
                    </div>
                </div>
            `
        } else {
            const content = get(customOffcanvasContentSelector)
            get(customOffcanvasTitleSelector, customOffcanvas).innerHTML = `<p class="mb-0 text--darkgray">${e.target.textContent}</p>`
            const menuId = e.target.closest('[data-menu]').dataset.menu
            const menuList = get('.js-submenu-group')
            const currentSubmenu = get(`[data-submenu=${menuId}]`, menuList)

            content.insertAdjacentHTML('beforeend', currentSubmenu.outerHTML)
        }
    }

    const handleCloseOffcanvas = () => {
        const customOffcanvas = get(customOffcanvasSelector)
        removeClass(customOffcanvas, 'active')
        addClass(customOffcanvas, 'non-active')

        const content = get(customOffcanvasContentSelector)
        content.innerHTML = ''
    }

    return new Component({
        name: 'menuAdaptive',
        requiredTargets: [customOffcanvasSelector, adaptiveButtonSelector, customOffcanvasBackSelector, customOffcanvasContentSelector],
        onInit() {
            $events.delegate
                .on('click', adaptiveButtonSelector, handleOpenOffcanvas)
                .on('click', customOffcanvasBackSelector, handleCloseOffcanvas)
        },
        onDestroy() {
            $events.delegate
                .off('click', adaptiveButtonSelector, handleOpenOffcanvas)
                .off('click', customOffcanvasBackSelector, handleCloseOffcanvas)
        },
    })

}
